import { computed } from 'vue'

import { usePlanStore } from './usePlanStore'
import { getResourceLimit, getResourceUsage } from './limitAndUsage'
import { Resource } from './planTypes'
import { useBillingStore } from './useBillingStore'
import { defineComposable } from '@/core/utils/defineComposable'

/**
 * Single source of truth for the STORAGE_INTEGRATIONS billing plan resource
 * Interprets all the customer billing records in order to tell us the customer's
 * usage and limits.
 *
 * This is still a stub and should be further developed
 */
export const useResourceStorageIntegration = defineComposable(() => {
  const planStore = usePlanStore()
  const billingStore = useBillingStore()

  const isStorageIntegrationAtLimit = computed(() => {
    const plan = planStore.customerPlan

    // if we have a plan an LBB customer,
    // so we only care about info contained in the plan
    if (plan) {
      const license = plan?.plan_licenses.find((l) => l.resource === Resource.STORAGE_INTEGRATION)
      // no license or no blocking license means no limit
      if (!license?.is_blocking) {
        return false
      }

      // blocking license means we check and enforce limit
      const totalLimit = getResourceLimit(plan, Resource.STORAGE_INTEGRATION)
      const totalUsage = getResourceUsage(plan, Resource.STORAGE_INTEGRATION)
      return totalUsage >= totalLimit
    }

    // fallback to classic CBB customer
    const cbbSubscription = billingStore.billingInfo?.customer_subscription
    if (!cbbSubscription) {
      return true
    }

    const { external_storage_buckets, external_storage_buckets_used } = cbbSubscription
    return external_storage_buckets <= external_storage_buckets_used
  })

  const isReady = computed(
    () => planStore.hasCustomerPlanLoaded && !billingStore.billingInfoLoading,
  )

  return { isStorageIntegrationAtLimit, isReady }
})
